export default "https://housescan.app.solease.nl/static/media/home_battery.b7dc4254.svg";